// A6 auto-moderation rule engine — module-local data layer. REAL backend
// (/admin/moderation/rules, /admin/moderation/test, /admin/moderation/flags).
// Review-only: rules flag matching messages into a queue; никогда auto-acts.
import { api } from '@/lib/api'

export interface ModRule {
  id: number
  pattern: string
  is_regex: boolean
  category: string
  severity: string
  action: string
  enabled: boolean
  note: string
  flags: number
}
export interface ContentFlag {
  id: number
  message_id: number
  dialog_id: number | null
  sender_id: number | null
  category: string
  severity: string
  matched_text: string
  status: string
  created_at: string
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchRules = (s?: AbortSignal) =>
  api.get<{ rules: ModRule[] }>('/admin/moderation/rules', opt(s)).then((d) => d.rules ?? [])
export const createRule = (body: {
  pattern: string
  is_regex: boolean
  category: string
  severity: string
  action: string
  note?: string
}) => api.post<{ id: number }>('/admin/moderation/rules', body)
export const updateRule = (id: number, body: Partial<{ enabled: boolean; category: string; severity: string; action: string; note: string }>) =>
  api.put(`/admin/moderation/rules/${id}`, body)
export const deleteRule = (id: number) => api.del(`/admin/moderation/rules/${id}`)
export const testRule = (pattern: string, is_regex: boolean, sample: string) =>
  api.post<{ matched: boolean }>('/admin/moderation/test', { pattern, is_regex, sample })

export const fetchFlags = (status = '', s?: AbortSignal) =>
  api
    .get<{ flags: ContentFlag[] }>('/admin/moderation/flags', {
      query: status ? { status } : {},
      ...(s ? { signal: s } : {}),
    })
    .then((d) => d.flags ?? [])
export const resolveFlag = (id: number, action: 'dismiss' | 'action') =>
  api.post(`/admin/moderation/flags/${id}/${action}`, {})

export const CATEGORIES = ['spam', 'csam', 'violence', 'fraud', 'copyright', 'doxxing', 'other'] as const
export const SEVERITIES = ['low', 'medium', 'high'] as const
export const ACTIONS = ['flag', 'review', 'urgent'] as const

export const AM_STR = {
  rules: 'Авто-модерация: правила',
  rulesDesc: 'Ключевые слова / regex → флаг в очередь на проверку (никогда авто-бан)',
  flags: 'Флаги контента (проверка)',
  flagsDesc: 'Сообщения, отмеченные правилами — на ручную проверку',
  pattern: 'Шаблон',
  regex: 'Regex',
  category: 'Категория',
  severity: 'Уровень',
  action: 'Действие',
  note: 'Примечание',
  enabled: 'Вкл',
  matches: 'Флагов',
  add: 'Добавить правило',
  test: 'Тест',
  testSample: 'Пример текста…',
  matched: 'Совпадение ✓',
  noMatch: 'Нет совпадения',
  delete: 'Удалить',
  message: 'Сообщение',
  matchedText: 'Текст',
  status: 'Статус',
  created: 'Когда',
  dismiss: 'Отклонить',
  actionBtn: 'Принять меры',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет данных',
  emptyFlags: 'Нет флагов на проверку',
  refresh: 'Обновить',
  all: 'Все',
  pending: 'Ожидают',
} as const
